import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'
import { InvoiceEditorDocumentType } from '../../types/invoiceEditorDocumentType'
import { InvoiceEditorSourceDocumentType } from '../../types/invoiceEditorSourceDocumentType'

interface InvoiceEditorVariantDocumentTypes {
  documentType: InvoiceEditorDocumentType
  sourceDocumentType: InvoiceEditorSourceDocumentType
}

export const invoiceEditorVariantDocumentTypes: Record<InvoiceEditorVariant, InvoiceEditorVariantDocumentTypes> = {
  [InvoiceEditorVariant.CreditNoteFromInvoice]: {
    documentType: InvoiceDocumentType.CreditNote,
    sourceDocumentType: InvoiceDocumentType.Invoice,
  },
  [InvoiceEditorVariant.InvoiceDraftDuplicate]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.InvoiceDraft,
  },
  [InvoiceEditorVariant.InvoiceDraftEdit]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.InvoiceDraft,
  },
  [InvoiceEditorVariant.DepositInvoiceDraftEdit]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.InvoiceDraft,
  },
  [InvoiceEditorVariant.FinalInvoiceDraftEdit]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.InvoiceDraft,
  },
  [InvoiceEditorVariant.InvoiceDuplicate]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.Invoice,
  },
  [InvoiceEditorVariant.InvoiceNew]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.Invoice,
  },
  [InvoiceEditorVariant.QuoteDraftDuplicate]: {
    documentType: InvoiceDocumentType.Quote,
    sourceDocumentType: InvoiceDocumentType.QuoteDraft,
  },
  [InvoiceEditorVariant.QuoteDraftEdit]: {
    documentType: InvoiceDocumentType.Quote,
    sourceDocumentType: InvoiceDocumentType.QuoteDraft,
  },
  [InvoiceEditorVariant.QuoteDuplicate]: {
    documentType: InvoiceDocumentType.Quote,
    sourceDocumentType: InvoiceDocumentType.Quote,
  },
  [InvoiceEditorVariant.QuoteEdit]: {
    documentType: InvoiceDocumentType.Quote,
    sourceDocumentType: InvoiceDocumentType.Quote,
  },
  [InvoiceEditorVariant.QuoteNew]: {
    documentType: InvoiceDocumentType.Quote,
    sourceDocumentType: InvoiceDocumentType.Quote,
  },
  [InvoiceEditorVariant.InvoiceNewFromQuote]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.Quote,
  },
  [InvoiceEditorVariant.DepositInvoiceNewFromQuote]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.Quote,
  },
  [InvoiceEditorVariant.FinalInvoiceNewFromQuote]: {
    documentType: InvoiceDocumentType.Invoice,
    sourceDocumentType: InvoiceDocumentType.Quote,
  },
  [InvoiceEditorVariant.RecurringInvoiceDraftEdit]: {
    documentType: InvoiceDocumentType.RecurringInvoice,
    sourceDocumentType: InvoiceDocumentType.RecurringInvoiceDraft,
  },
  [InvoiceEditorVariant.RecurringInvoiceDuplicate]: {
    documentType: InvoiceDocumentType.RecurringInvoice,
    sourceDocumentType: InvoiceDocumentType.RecurringInvoice,
  },
  [InvoiceEditorVariant.RecurringInvoiceEdit]: {
    documentType: InvoiceDocumentType.RecurringInvoice,
    sourceDocumentType: InvoiceDocumentType.RecurringInvoice,
  },
  [InvoiceEditorVariant.RecurringInvoiceNew]: {
    documentType: InvoiceDocumentType.RecurringInvoice,
    sourceDocumentType: InvoiceDocumentType.RecurringInvoice,
  },
}
